import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";

export default {
  async getImporterSchemaByEntity({ commit }, { entity }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/importer-schemas",
        method: "GET",
        params: { entity },
      });

      commit(MutationsType.SET_IMPORTER_SCHEMAS, response.data.data);
      return response.data.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async saveImporterSchema({ commit, state }, { entity, name, schema }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/importer-schemas",
        method: "POST",
        data: {
          entity,
          name,
          schema,
        },
      });

      commit(MutationsType.SET_IMPORTER_SCHEMAS, [...state.importerSchemas, response.data.data]);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};
